import imageCompression from 'browser-image-compression';

export async function compressFile(files, quality = 0.5) {
  return Promise.all(
    [...files].map(async (file) => {
      try {
        if (file.type.startsWith('image/')) {
          const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
            quality: quality
          };
          
          const compressedFile = await imageCompression(file, options);
          return new File([compressedFile], file.name, {
            type: file.type,
            lastModified: Date.now(),
          });
        }
        return file; // Return original file if not an image
      } catch (error) {
        console.error('Error compressing file:', error);
        return file; // Return original file if compression fails
      }
    })
  );
}